<script>
	import LazyImg from "./LazyImg.svelte";

	export let image1;
	export let image2;
	export let image3;
	export let subtitle1;
	export let subtitle2;
	export let subtitle3;
	export let subtitleFull;
</script>

<div class="threeimages">
	<div class="image">
		<LazyImg src="{PATH}images/{image1}" />
		{#if subtitle1} <div>{subtitle1}</div> {/if}
	</div>

	<div class="bottom">
		<div class="image">
			<LazyImg src="{PATH}images/{image2}" />
			{#if subtitle2} <div>{subtitle2}</div> {/if}
		</div>

		<div class="image">
			<LazyImg src="{PATH}images/{image3}" />
			{#if subtitle3} <div>{subtitle3}</div> {/if}
		</div>
	</div>
	<div class="subtitle-full">
		{#if subtitleFull} <div>{subtitleFull}</div> {/if}
	</div>
</div>

<style>
	.threeimages {
		margin: 70px auto;
	}

	.threeimages > .image:first-child {
		width: 100%;
		max-width: 1020px;
		margin: 40px auto;
	}

	@media (max-width: 580px) {
		.threeimages > .image:first-child {
			margin: 0 auto;
		}

		.threeimages {
			margin: 40px auto;
		}
	}

	.threeimages .bottom {
		display: flex;
		width: 100%;
		max-width: 1020px;
    margin: 40px auto;
    justify-content: space-between;
	}

	@media (max-width: 580px) {
		.threeimages .bottom {
			display: block;
			margin: 0 auto;
		}
	}

	.threeimages .bottom .image {
		flex-shrink: 1;
		flex-grow: 0;
	}

	.threeimages .image {
		max-width: calc(50% - 8px);
		margin-bottom: 20px;
		box-sizing: border-box;
	}

	@media (max-width: 580px) {
		.threeimages .image {
			max-width: 100%;
			padding: 1px 20px 20px 20px;
			box-sizing: border-box;
			margin-bottom: 0px;
		}

		.threeimages .bottom:last-child {
			margin-bottom: 20px;
		}
	}

	:global(.threeimages .image img) {
		max-width: 100%;
	}

	.threeimages .image div,
	.subtitle-full {
		margin-top: 16px;
    /*font-family: "Abril Text", Georgia, Times, serif;*/
		font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
		font-size: 17px;
		line-height: 25px;
	}

	.subtitle-full {
		width: 100%;
		max-width: 1020px;
		margin: -40px auto 40px auto;
	}

	@media (max-width: 580px) {
		.subtitle-full {
			margin-top: 0px;
			margin-left: 20px;
			margin-right: 20px;
			width: unset;
		}
	}
</style>
